import { render, staticRenderFns } from "./InvoiceFromOracle.vue?vue&type=template&id=b0668740&"
import script from "./InvoiceFromOracle.vue?vue&type=script&lang=js&"
export * from "./InvoiceFromOracle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports